import React, { useState } from "react";
import { ItemInput } from "../../../../@types";
import { ServiceData, ServicePriceData } from "../../../../@types/service";
import { createNewService } from "../../../../backend-services/service";
import { validateCreateService } from "../../../../modules/services/services";
import { convertToFloat } from "../../../../utils/convertToFloat";
import ServiceOverlay from "./serviceOverlay";
import { useTranslation } from "react-i18next";
import { useCompanyStore } from "../../../../state/useCompanyStore";
import { useGetPaymentCurrencyList } from "../../../../utils";
import { showToast } from "../../../../utils/toastUtils";

interface CreateServiceProps {
  show: boolean;
  onClose?: () => void;
  setShowCreateService: (show: boolean) => void;
  // onCreateSuccess: (newService: ServiceData) => void;
  onCreateSuccess: (newItem: ItemInput) => void;
  serviceType?: "time-based" | "session-based";
}

const CreateServiceModal = ({
  show,
  onClose,
  setShowCreateService,
  onCreateSuccess,
  serviceType,
}: CreateServiceProps) => {
  const { t } = useTranslation("services");
  const [isOpen, setIsOpen] = React.useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [price, setPrice] = useState<ServicePriceData[]>([]);
  const [serviceData, setServiceData] = useState<ServiceData>({
    name: "",
    duration: "",
    description: "",
    price: [],
    status: "Active",
    serviceType: "time-based",
  });
  const companyProfile = useCompanyStore();
  const { userCurrencyCode } = useGetPaymentCurrencyList(
    companyProfile.company,
  );
  const userLocalCurrency = userCurrencyCode.currency;
  const userCountry = companyProfile.company.country === "US" ? "CAD" : "USD";

  const [error, setError] = React.useState({
    name: "",
    charge: {},
  });
  const handleCreateService = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const newPrice = price.map((item) => ({
      ...item,
      amount: convertToFloat(item.amount),
    }));

    const { hasErrors, errors } = validateCreateService({
      name: serviceData.name,
      duration: serviceData.duration,
      description: serviceData.description,
      price: newPrice,
      userLocalCurrency,
      userCountry,
      serviceType: serviceData.serviceType,
    });

    if (hasErrors) {
      setError(errors);
    } else {
      try {
        setIsLoading(true);
        const newServiceData = {
          ...serviceData,
          price: newPrice,
          serviceType: serviceData.serviceType,
        };

        const response = await createNewService(newServiceData);
        showToast(t("service.successToast"), "success");
        setShowCreateService(false);
        setIsLoading(false);
        setServiceData({
          name: "",
          duration: "",
          description: "",
          price: [],
          status: "Active",
          serviceType: serviceData.serviceType,
        });

        onCreateSuccess(response);
      } catch (error) {
        setIsLoading(false);
        console.error("Error creating service:", error);
      }
    }
  };
  const handleClose = () => {
    setIsOpen(false);
    onClose && onClose();
  };
  return (
    <>
      <ServiceOverlay
        showBack={false}
        setShowCreateService={setShowCreateService}
        handleCreateService={handleCreateService}
        onCreateSuccess={onCreateSuccess}
        serviceType={serviceType}
      />
    </>
  );
};

export default CreateServiceModal;
